
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"31","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.549 0C3.403 3.596 0 9.199 0 15.47 0 20.906 3.486 24 7.387 24c3.569 0 6.557-3.01 6.557-6.606s-2.49-6.021-5.644-6.021c-.664 0-1.411.083-1.66.25.747-3.01 3.818-6.522 6.474-7.944L8.549 0zm16.849 0c-5.146 3.596-8.466 9.199-8.466 15.47 0 5.436 3.403 8.53 7.304 8.53 3.651 0 6.556-3.01 6.556-6.606s-2.49-6.021-5.56-6.021c-.664 0-1.411.083-1.66.25.664-3.01 3.818-6.522 6.474-7.944L25.398 0z","fill":"#B096CB"}})])
          )
        }
      }
    